import { t } from 'src/i18n';
import IconArrowUp from '../../../assets/svg/icon-arrow-up.svg';
import IconArrowDown from '../../../assets/svg/icon-arrow-down.svg';
import IconEnter from '../../../assets/svg/icon-enter.svg';
import { SearchFooter } from './globalSearchFooter.style';

const GlobalSearchFooter = () => {
  return (
    <SearchFooter>
      <div className="footer-action-group">
        <div className="keyboard-shortcut-key">
          <img alt="" src={IconArrowUp} />
        </div>
        <div className="keyboard-shortcut-key">
          <img alt="" src={IconArrowDown} />
        </div>
        {t('dash.globalSearch.navigate_label')}
      </div>

      <div className="footer-action-group">
        <div className="keyboard-shortcut-enter">
          <img alt="" src={IconEnter} />
        </div>
        {t('dash.globalSearch.select_label')}
      </div>
    </SearchFooter>
  );
};

export default GlobalSearchFooter;
